module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\n<fieldset class="gererbadgeages-detail">\n  <span class="collaborateur ctxGestionCollab"></span> <br/><br/>\n  <span class="periode"></span> <br/><br/>\n  <span class="table_badgeages"></span>\n</fieldset>';
}
return __p;
};
